import { render, staticRenderFns } from "./vanity.vue?vue&type=template&id=79dfcf92&"
import script from "./vanity.vue?vue&type=script&lang=js&"
export * from "./vanity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports